import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { getFormattedDspName } from '@App/helpers/get-dsp-name'
import { formatReleaseDate } from '@App/helpers/format-release-date'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import React from 'react'
import { ZodFormattedError } from 'zod'
import { RecordingModel } from '@Entities/work/recording-model'

interface RecordingsTableRowProps {
    recording: RecordingModel
    recordingType: 'matched' | 'registration'
    error?: ZodFormattedError<RecordingModel>
}

const RecordingsTableRow = ({ recording, recordingType, error }: RecordingsTableRowProps) => (
    <tr>
        <td data-label="Recording Artist">
            <div>
                <span>{tableCellSanitizer(stringEscapeNewlines(recording.artistName))}</span>
                <span className="error-field">{error?.artistName?._errors?.join(', ')}</span>
            </div>
        </td>
        <td data-label="Recording Title">
            <div>
                <span>{tableCellSanitizer(stringEscapeNewlines(recording.title))}</span>
                <span className="error-field">{error?.title?._errors?.join(', ')}</span>
            </div>
        </td>
        <td data-label="ISRC">
            <div>
                <span>{tableCellSanitizer(recording.isrc)}</span>
                <span className="error-field">{error?.isrc?._errors?.join(', ')}</span>
            </div>
        </td>
        <td data-label={recordingType === 'matched' ? 'DSP' : 'Release Date'}>
            <div>
                {recordingType === 'matched' ? (
                    <span>{getFormattedDspName(recording.dsp)}</span>
                ) : (
                    <span>{formatReleaseDate(recording.releaseDate)}</span>
                )}
            </div>
        </td>
        <td data-label="Label">
            <div>
                <span>{recording.label && tableCellSanitizer(stringEscapeNewlines(recording.label))}</span>
                <span className="error-field">{error?.label?._errors?.join(', ')}</span>
            </div>
        </td>
        <td data-label="Duration">
            <div>
                <span>{tableCellSanitizer(recording.duration, '--:--')}</span>
                <span className="error-field">{error?.duration?._errors?.join(', ')}</span>
            </div>
        </td>
    </tr>
)

export default RecordingsTableRow
